import React from 'react'

function Footer() {
    return (
        <div style={{
            padding: 15,
            marginTop: 'auto'
        }}>
            Credits: Permutation method to <a href="https://www.youtube.com/watch?v=CqPJnvGJKu8" target="_blank">Austin John Plays</a>. Every permutations combinations to Smitty12 and Austin John Plays discord users.
        </div>
    )
}

export default Footer